import React from 'react';
import { Avatar, Button, Tooltip } from 'antd';
import {
  ArrowsAltOutlined,
  MinusOutlined,
  ShrinkOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';

// Barra de título: é a alça do arrasto; as ações ficam fora dela (`cancel` do Draggable).
function TitleBar({
  name,
  initials,
  avatar,
  hourLabel,
  status,
  whatsapp,
  canResize,
  size,
  onToggleSize,
  onMinimize,
}) {
  const expanded = size === 'normal';

  return (
    <div className="tmd-titlebar">
      <div className="tmd-titlebar-id">
        <Avatar className="tmd-avatar" size={36} src={avatar || undefined}>
          {initials}
        </Avatar>
        <div className="tmd-titlebar-texts">
          <span className="tmd-name">{name}</span>
          <div className="tmd-titlebar-meta">
            <span className={`tmd-live tmd-live-${status.tone}`}>
              <span className="tmd-live-dot" />
              {status.label}
            </span>
            {hourLabel ? <span className="tmd-hour">{hourLabel}</span> : null}
          </div>
        </div>
      </div>

      <div className="tmd-titlebar-actions">
        {whatsapp ? (
          <Tooltip title="Chamar no WhatsApp">
            <Button
              type="text"
              className="tmd-winbtn"
              icon={<WhatsAppOutlined />}
              aria-label="Chamar no WhatsApp"
              onClick={() => window.open(whatsapp, '_blank', 'noopener')}
            />
          </Tooltip>
        ) : null}
        {canResize ? (
          <Tooltip title={expanded ? 'Reduzir' : 'Ampliar'}>
            <Button
              type="text"
              className="tmd-winbtn"
              icon={expanded ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
              aria-label={expanded ? 'Reduzir' : 'Ampliar'}
              onClick={onToggleSize}
            />
          </Tooltip>
        ) : null}
        <Tooltip title="Minimizar">
          <Button
            type="text"
            className="tmd-winbtn"
            icon={<MinusOutlined />}
            aria-label="Minimizar"
            onClick={onMinimize}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default TitleBar;
